import { Get } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import Employee from './Employee';
import EmployeeQueryOptions from './EmployeeQueryOptions';
import { QueryParameters, buildQueryParams } from '../QueryParameters';

export const getEmployees = (query: QueryParameters<Employee, EmployeeQueryOptions>): Promise<PagedResponse<Employee>> => (
  Get('/api/employees')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getEmployee = (employeeId: number): Promise<Employee> => (
  Get(`/api/employees/${employeeId}`)
    .Execute()
);
